<template>
	<div class="dashboard-box">
		<section class="top-box">
			<div class="header-cls">
				<div class="left-cls">
					<svg-icon iconClass="CallIcon"></svg-icon>
					<span class="title">InBound</span>
				</div>
				<div class="right-cls">
					<svg-icon iconClass="ImIcon" />
					<span class="title">OutBound</span>
				</div>
			</div>
			<div class="container">
				<div class="top-box-container-left">
					<div class="top-box-container-left-left">
						<div id="chart" style="width:100%;height:260px;"></div>
					</div>
					<div class="top-box-container-left-right">
						<div id="chart1" style="width:100%;height:260px;"></div>
						<div class="top-box-container-left-right-le">
							<el-tag type="danger" effect="dark">＜95%</el-tag>
							<el-tag type="success" effect="dark">≥95%</el-tag>
						</div>
					</div>
				</div>
				<div class="top-box-container-right">
					<el-tooltip class="item" effect="dark" content="当日超过10分钟未执行第一次外呼的任务数量" placement="top">
						<div class="cell">
							<div class="count">{{resultData.yhlq || 0}}</div>
							<div class="text">一呼临期量 > 10min</div>
						</div>
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="当日线索中心推送的线索总数量" placement="top">
						<div class="cell">
							<div class="count">{{resultData.xsl || 0}}</div>
							<div class="text">线索量</div>
						</div>
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="当日分配的外呼任务总量" placement="top">
						<div class="cell">
							<div class="count">{{resultData.fpl || 0}}</div>
							<div class="text">分配量</div>
						</div>
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="当日执行的外呼任务总量" placement="top">
						<div class="cell">
							<div class="count">{{resultData.zwhl || 0}}</div>
							<div class="text">总外呼量</div>
						</div>
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="当日未执行的一呼剩余量" placement="top">
						<div class="cell">
							<div class="count">{{resultData.yhsyl || 0}}</div>
							<div class="text">一呼剩余量</div>
						</div>
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="当日未完成的外呼任务总量" placement="top">
						<div class="cell">
							<div class="count">{{resultData.syzl || 0}}</div>
							<div class="text">总剩余量</div>
						</div>
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="当日成功接通的一呼任务量/当日执行的一呼任务总量" placement="top">
						<div class="cell">
							<div class="count">{{resultData.yhjtl || '0%'}}</div>
							<div class="text">一呼接通率</div>
						</div>
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="当日所有成功接通的任务量/当日执行的任务总量" placement="top">
						<div class="cell">
							<div class="count">{{resultData.zjtl || '0%'}}</div>
							<div class="text">总接通率</div>
						</div>
					</el-tooltip>
				</div>
			</div>
		</section>

		<section class="bottom-box">
			<section class="left">
				<div class="header-cls">
					<div class="left-cls">
						<svg-icon iconClass="CallSeat"></svg-icon>
						<span class="title">实时坐席状态</span>
					</div>
				</div>
				<div class="container">
					<div class="left-cls">
						<div class="left-cls">
							<div class="label">电话渠道</div>
							<div class="type-cls">
								<div class="item">
									<span>就绪</span>
									<span>{{resultData.waitingNum || 0}}</span>
								</div>
								<div class="item">
									<span>置忙</span>
									<span>{{resultData.busyNum || 0}}</span>
								</div>
								<div class="item">
									<span>通话中</span>
									<span>{{resultData.callNum || 0}}</span>
								</div>
								<div class="item">
									<span>后处理</span>
									<span>{{resultData.acwNum || 0}}</span>
								</div>
								<div class="item">
									<span>登录人数</span>
									<span>{{resultData.loginNum || 0}}</span>
								</div>
							</div>
							<div class="label-cls">
								<div class="item">
									<i class="jx"></i>
									<span>就绪</span>
								</div>
								<div class="item">
									<i class="zm"></i>
									<span>置忙</span>
								</div>
								<div class="item">
									<i class="thz"></i>
									<span>通话中</span>
								</div>
								<div class="item">
									<i class="zlz"></i>
									<span>振铃中</span>
								</div>
								<div class="item">
									<i class="hcl"></i>
									<span>后处理</span>
								</div>
								<div class="item">
									<i class="lx"></i>
									<span>离线</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section class="right">
				<div class="container">
					<div class="right-cls">
						<div class="table-box">
							<div class="thead">
								<div>坐席</div>
								<div>分机</div>
								<div>话机状态</div>
								<div>持续时间</div>
								<div>分配量</div>
								<div>处理量</div>
								<div>总剩余</div>
								<div>接通率</div>
							</div>
							<div class="tbody">
								<div v-for="(item, index) in list" :key="index">
									<div>{{item.agentNickname}}</div>
									<div>{{item.deviceCode}}</div>
									<div :class="item.state">{{item.state}}</div>
									<div>{{item.duration}}</div>
									<div>{{item.fpl}}</div>
									<div>{{item.cll}}</div>
									<div>{{item.zsy}}</div>
									<div>{{item.jtlv}}</div>
								</div>
								<el-empty v-if="list.length == 0" description="暂无数据"></el-empty>
							</div>
						</div>
					</div>
				</div>
			</section>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.dashboard-box {
    width: 100%;

	& > .top-box {
		width: 100%;

		& > .header-cls {
			width: 100%;
			height: 40px;
			background: #F3F6FA;

			& > .left-cls {
				padding: 0 16px 0 20px;
				width: calc(50% - 8px);
				height: 100%;
				vertical-align: top;
				display: inline-block;
				margin-right: 16px;
			}
			& > .right-cls {
				padding: 0 0 0 15px;
				width: calc(50% - 8px);
				height: 100%;
				vertical-align: top;
				display: inline-block;
			}

			& .svg-icon:nth-of-type(1) {
				display: inline-block;
				vertical-align: top;
				font-size: 18px;
				color: #545454;
				margin-top: 11px;
				margin-right: 8px;
			}


			& .title {
				vertical-align: top;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #545454;
				line-height: 40px;
			}
		}

		& > .container {
			width: 100%;
			height: 332px;

			& > .top-box-container-left {
				width: calc(50% - 2px);
				height: 100%;
				display: inline-block;
				vertical-align: top;
				margin-right: 4px;
				background: #FFFFFF;
				border-radius: 4px;
				overflow: hidden;
				padding: 30px 12px;
				box-sizing: border-box;
				position: relative;

				& > .top-box-container-left-left {
					width: 50%;
					height: 100%;
					display: inline-block;
					vertical-align: top;
				}

				& > .top-box-container-left-right {
					width: 50%;
					height: 100%;
					display: inline-block;
					vertical-align: top;

					& > .top-box-container-left-right-le {
						text-align: center;
						& .el-tag {
							margin: 0 5px;
						}
					}
				}
			}

			& > .top-box-container-right {
				display: inline-block;
				vertical-align: top;
				width: calc(50% - 2px);
				height: 100%;
				background: #FFFFFF;
				border-radius: 4px;
				overflow: hidden;
				padding: 30px 0;
				box-sizing: border-box;

				& > .cell {
					width: calc((100% - 96px) / 4);
					height: 100px;
					margin: 12px;
					margin-bottom: 24px;
					border: 1px solid rgba(113, 122, 146, 0.26);
					border-radius: 11px;
					padding-top: 15px;
					background: #FDFDFD;
					text-align: center;
					position: relative;
					display: inline-block;

					&::before {
						content: "";
						width: 88px;
						height: 1px;
						background: #D9D9D9;
						position: absolute;
						top: calc((100% + 5px) / 2);
						left: calc((100% - 88px) / 2);
					}

					& > .count {
						font-size: 16px;
						font-family: Arial-Black, Arial;
						font-weight: 900;
						color: #646A76;
						line-height: 30px;
						margin-bottom: 20px;
					}

					& > .text {
						font-size: 12px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #8A94A3;
						line-height: 20px;
					}
				}
			}
		}
	}

	& > .bottom-box {
		width: 100%;
		height: 350px;
		overflow: hidden;

		& > section {
			display: inline-block;
			vertical-align: top;
			&.left {
				width: 280px;

				& > .header-cls {
					width: 100%;
					height: 40px;
					background: #F3F6FA;

					& > .left-cls {
						padding: 0 16px 0 20px;
						width: calc(50% - 8px);
						height: 100%;
						vertical-align: top;
						display: inline-block;
						margin-right: 16px;
					}
					& > .right-cls {
						padding: 0 0 0 15px;
						width: calc(50% - 8px);
						height: 100%;
						vertical-align: top;
						display: inline-block;
					}

					& .svg-icon:nth-of-type(1) {
						display: inline-block;
						vertical-align: top;
						font-size: 18px;
						color: #545454;
						margin-top: 11px;
						margin-right: 8px;
					}


					& .title {
						vertical-align: top;
						font-size: 14px;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #545454;
						line-height: 40px;
					}
				}

				& > .container {
					width: 100%;
					background: #FFFFFF;

					& > div {
						display: inline-block;
						vertical-align: top;
						width: 280px;
						height: 100%;
						background: #FFFFFF;
						overflow: hidden;

						&.left-cls {
							height: 100%;
							padding: 33px 0 0 50px;
						}

						& > .left-cls {
							display: inline-block;
							width: 229px;
							height: 100%;
							vertical-align: top;

							& > .label {
								font-size: 12px;
								font-family: PingFangSC-Semibold, PingFang SC;
								font-weight: 600;
								color: #40516D;
								line-height: 12px;
								margin-bottom: 12px;
							}

							& > .type-cls {
								width: 187px;
								height: 125px;
								position: relative;
								border-radius: 4px;
								background-image: url('../../../../public/static/images/bgss.png');
								background-size: 100% 100%;
								background-repeat: no-repeat;
								padding: 11px 31px 0 36px;
								margin-bottom: 29px;

								& > .item {
									font-size: 12px;
									font-family: PingFangSC-Regular, PingFang SC;
									font-weight: 400;
									color: #646A76;
									line-height: 20px;
									height: 20px;
									vertical-align: top;
									margin-bottom: 1px;

									& > span {
										display: inline-block;
										width: 85px;
										text-align: left;

										&:nth-of-type(2) {
											width: calc(100% - 85px);
											text-align: right;
											font-family: Arial-Black, Arial;
											font-weight: 900;
											color: #40516D;
										}
									}
								}
							}

							& > .label-cls {
								width: 100%;
								height: 100px;

								& > .item {
									width: 110px;
									margin-bottom: 13px;
									// display: inline-block;
									float: left;
									vertical-align: top;
									font-size: 12px;
									font-family: PingFangSC-Regular, PingFang SC;
									font-weight: 400;
									color: #646464;
									line-height: 14px;
									height: 14px;

									& > i {
										display: inline-block;
										width: 8px;
										height: 8px;
										border-radius: 50%;
										background-color: red;
										margin-right: 5px;

										&.jx {
											background: #00DC99;
										}
										&.zm {
											background: #FF6378;
										}
										&.thz {
											background: #337EFF;
										}
										&.zlz {
											background: #FFD05E;
										}
										&.hcl {
											background: #4B2357;
										}
										&.lx {
											background: #CACACA;
										}
									}
								}
							}
						}
					}
				}
			}

			&.right {
				width: calc(100% - 280px);

				& > .container {
					width: 100%;
					background: #FFFFFF;

					& > div {
						display: inline-block;
						vertical-align: top;
						width: 280px;
						height: 100%;
						background: #FFFFFF;
						overflow: hidden;

						&.right-cls {
							width: 100%;
							height: 350px;
							overflow-x: hidden;
							overflow-y: auto;

							& .table-box {
								width: 100%;
								height: 350px;
								overflow: hidden;

								& > .thead {
									width: 100%;
									height: 40px;
									border-right: 1px solid #ebeef5;
									& > div {
										display: inline-block;
										width: calc(100% / 8);
										height: 40px;
										line-height: 40px;
										background: #f5f7fa;
										font-size: 14px;
										border: 1px solid #ebeef5;
										border-right: none;
										border-bottom: none;
										padding: 0 15px;
										color: #666;
										font-weight: bold;
									}
								}

								& > .tbody {
									width: 100%;
									height: 310px;
									overflow-x: hidden;
									overflow-y: auto;
									border-right: 1px solid #ebeef5;
									&::-webkit-scrollbar {
										height: 0;
										width: 0;
									}

									& > div > div {
										display: inline-block;
										width: calc(100% / 8);
										line-height: 35px;
										color: #909399;
										font-size: 14px;
										padding: 0 15px;
										border: 1px solid #ebeef5;
										border-right: none;
										border-bottom: none;
										position: relative;

										&:nth-of-type(3) {
											padding-left: 20px;
										}

										&:nth-of-type(3)::before {
											content: '';
											width: 6px;
											height: 6px;
											border-radius: 50%;
											position: absolute;
											top: calc((36px - 6px) / 2);
											left: 8px;
										}

										&:nth-of-type(3).就绪::before {
											background: #00DC99;
										}
										&:nth-of-type(3).置忙::before {
											background: #FF6378;
										}
										&:nth-of-type(3).通话中::before {
											background: #337EFF;
										}
										&:nth-of-type(3).振铃中::before {
											background: #FFD05E;
										}
										&:nth-of-type(3).后处理::before {
											background: #4B2357;
										}
										&:nth-of-type(3).离线::before {
											background: #CACACA;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
}


</style>

<script>
import * as echarts from 'echarts';
export default {
	data() {
		let dataList = [
			{ value: 3, name: '等待量' },
			{ value: 5, name: '接起量' },
			{ value: 5, name: '进线量' },
			{ value: 4, name: '弃呼量' },
		];
		const colorList = ['#4D88FE', '#FFBF3C', '#50CCCB', '#909399'];
		return {
			option: {
				series: [
					{
						type: 'pie',
						radius: '70%',
						label: {
							position: 'inner',
							fontWeight:'bold',
							formatter: function (params) {
								if (params.name === '等待量') {
									return params.name + '\n\n' + `${params.value}`;
								}else if(params.name === '接起量'){
									return params.name + '\n\n' + `${params.value}`;
								}else if(params.name === '进线量'){
									return params.name + '\n\n' + `${params.value}`;
								}else if(params.name === '弃呼量'){
									return params.name + '\n\n' + `${params.value}`;
								}
							},
						},
						labelLine: {
							length: 10,
							length2: 40,
						},
						itemStyle: {
							normal: {
							borderColor: '#fff',
							borderWidth: 2,
								color: function (params) {
									return colorList[params.dataIndex];
								},
							},
						},
						data: [],
					},
				]
			},
			option1: {
				title: [
					{
						text: '接通率',
						left: 'center'
					},
					{
						text: '0%',
						textStyle: {
							color: "#0f0f0f",
							fontSize: 36,
							fontWeight:"500",
						},
						left: "50%",
						top: "40%",
						textAlign: "center",
					},
				],
				series: [
					{
						type: "pie",
						radius: ["50%", "66%"],
						itemStyle: {
							borderRadius: 4,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							normal: {
							show: false,
							},
						},
						data: [
							{ 
								value: 0, 
								name: '≥95%', 
								itemStyle: {
									normal: {
										color: '#67C23A'
									}
								}
							},
							{ 
								value: 100, 
								name: '<95%', 
								itemStyle: {
									normal: {
										color: '#909399'
									}
								}
							}
						],
					},
				
				],
			},
			list: [],
			resultData: {
				iCallNum: 0,
				iAnswerNum: 0,
				iGiveupNum: 0,
				iWaitingNum: 0,
				iAnswerRate: "0%",
				loginNum: 0,
				waitingNum: 0,
				busyNum: 0,
				callNum: 0,
				acwNum: 0,
				yhlq: 0,
				xsl: 0,
				fpl: 0,
				zwhl: 0,
				yhsyl: 0,
				syzl: 0,
				yhjtl: "0%",
				zjtl: "0%",
				agentList: []
			},
			timer: null
		}
	},
	async mounted(){
		await this.drawLine();
		this.timer = setInterval(() => {
			this.drawLine();
		}, 30000);
	},
	methods: {
		drawLine(){
			const self = this;
			self.$api.getPostImCustomDashboard().then(response => {
				if(response.errcode != 0) return;
				self.resultData = Object.assign(self.resultData, response.data);
				let jx = [];
				let zm = [];
				let thz = [];
				let zlz = [];
				let hcl = [];
				let lx = [];
				for(const item of response?.data?.agentList) {
					if(item?.state == '就绪') {
						jx.push(item);
					}
					if(item?.state == '置忙') {
						zm.push(item);
					}
					if(item?.state == '通话中') {
						thz.push(item);
					}
					if(item?.state == '振铃中') {
						zlz.push(item);
					}
					if(item?.state == '后处理') {
						hcl.push(item);
					}
					if(item?.state == '离线') {
						lx.push(item);
					}
				}
				self.list = jx.concat(zm).concat(thz).concat(zlz).concat(hcl).concat(lx);
				const chart = echarts.init(document.getElementById('chart'));
				const chart1 = echarts.init(document.getElementById('chart1'));
				self.option['series'][0]['data'] = [
					{ value: response.data?.iWaitingNum || 0, name: '等待量' },
					{ value: response.data?.iAnswerNum || 0, name: '接起量' },
					{ value: response.data?.iCallNum || 0, name: '进线量' },
					{ value: response.data?.iGiveupNum || 0, name: '弃呼量' },
				];
				self.option1['title'][1]['text'] = response.data?.iAnswerRate || '0%';

				self.option1['series'][0]['data'] = [
					{ 
						value:  parseFloat(response.data?.iAnswerRate || 0), 
						name: '≥95%', 
						itemStyle: {
							normal: {
								color: parseFloat(response.data?.iAnswerRate || 0) < 95 ? '#F56C6C' : '#67C23A'
							}
						}
					},
					{ 
						value: (100 - parseFloat(response.data?.iAnswerRate)) || 100, 
						name: '<95%', 
						itemStyle: {
							normal: {
								color: '#909399'
							}
						}
					}
				];
				chart.setOption(self.option, true);
				chart1.setOption(self.option1, true);
			});
		},

	},
	destroyed() {
		clearInterval(this.timer);
	}
}
</script>
